<template>
<v-layout row justify-center>
  <v-dialog class="person_add" v-model="dialog" :overlay="true">
    <v-btn slot="activator" class="add" flat>
      <v-icon dark>add</v-icon>Add Photo</v-btn>
    <v-card class="phototo--card">
      <v-toolbar light>
        <v-toolbar-title>
          Add Photo
        </v-toolbar-title>
        <v-btn icon @click.native="dialog = false" dark>
        <!-- <v-btn icon @click="destroy()" dark> -->
          <v-icon class="phototo--close">close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-layout row wrap class="phototo">
        <v-flex md6>
        <vue-webcam ref='webcam'></vue-webcam>
        <v-btn type="button" @click="take_photo" color="primary" v-if='this.photo === null' class="phototo--buttons">Capture</v-btn>
        <v-btn type="button" @click="take_photo"  color="primary"  v-else>Retake</v-btn>
        </v-flex>
        <v-flex md6>
          <img :src="photo" alt="" class="phototo--capturedImage" />
          <v-btn type="button" @click="convertPhoto" color="primary" class="phototo--buttons">Upload</v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</v-layout>
</template>

<script>
import $ from 'jquery';
import VueWebcam from '../../static/webccc';
import {
  api
} from '../api.js';
import {
  axios,
  get,
  post
} from 'axios';
export default {
  name: 'patientPhoto',
  components: {
    VueWebcam
  },
  data() {
    return {
      photo: null,
      dialog: false
    }
  },
  methods: {
    take_photo() {
      this.photo = this.$refs.webcam.getPhoto();
    },
    destroy(){
      // this.$destroy()
    },
  beforeDestroy() {
    console.log('Main Vue destroyed')
  },
    convertPhoto() {
      const url = this.photo
      const token = localStorage.getItem('token')

      fetch(url)
        .then(res => res.blob())
        .then(blob => {
        console.log(blob)
          var fd = new FormData()
          const file = new File([blob], "filename.jpeg")
          fd.append("image", file)
          // Upload
          fetch(api + '/add_image', {method: 'POST', body: fd, headers:{token:token}})
          .then(res => res.json())
          .then(res =>{
            localStorage.setItem('profilePhotoId', res.image_id),
            localStorage.setItem('profilePhoto', res.url)
            if (res.status === true) {
              window.location.reload()
            }
          }
            )})
    }
  }
}
</script>

<style lang="css">
.add .icon {
  margin-right: 10px;
}
.person_add .dialog__activator {
  padding: 4rem 0.5rem;
  /* border: 1px dashed #018FFF; */
  border: 1px dashed #585858;
}
.phototo {
  margin-top: 2rem;
}
.phototo .md6{
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.phototo .md6 video{
  height: 300px;
  width: 400px;
  margin: auto;
  margin-top: 0px;
}
.phototo--card {
  background-color: #fff !important;
  /* background-color: #212121 !important; */
}
.toolbar__content {
  background-color: #fff;
  display: flex;
  justify-content: space-between;
}
.phototo--close {
  color: #000;
}
.phototo .btn {
  width: 200px;
  margin: 2rem auto;
}
.phototo--capturedImage {
  height: 300px;
  width: 400px;
  margin: auto;
  margin-top: 0px;
}
/* .phototo .md6 img {
  padding: 0rem 4rem;
} */
</style>



// WEBPACK FOOTER //
// src/components/VueWebcam.vue